import { SvgIcon, SvgIconProps } from '@material-ui/core';

/**
 * Should be the same as the VOC Now logo.
 * @see https://github.com/project44/portal-v2-ui/blob/1dc78d7d958fa3efa951acb414fdd65480743cbd/src/components/common/assets/logo-small.svg
 */
const P44LogoSmall = (props: SvgIconProps) => {
  return (
    <SvgIcon {...props} viewBox="0 0 36 36">
      <g fill="none" fillRule="nonzero">
        <path
          fill="#236092"
          d="M5.105 30.708c7.01 6.993 18.335 7.065 25.433.16.056-.055.114-.107.16-.16 7.07-7.072 7.07-18.537 0-25.609-7.102-6.878-18.407-6.787-25.397.206-6.99 6.993-7.078 18.301-.2 25.403"
        />
        <path
          fill="#FFF"
          d="M14.961 14.79h-3.167v4.985h-4.66L11.945 7h-3.24L4 19.734v3.117h7.794V28h3.167v-5.15H17v-3.075h-2.039zM28.96 14.79h-3.17v4.985H21.13L25.946 7h-3.24L18 19.734v3.117h7.79V28h3.17v-5.15H31v-3.075h-2.04z"
        />
      </g>
    </SvgIcon>
  );
};

export default P44LogoSmall;
